import { render, staticRenderFns } from "./AjustesOrigen.vue?vue&type=template&id=62955a12&scoped=true"
import script from "./AjustesOrigen.vue?vue&type=script&lang=js"
export * from "./AjustesOrigen.vue?vue&type=script&lang=js"
import style0 from "./AjustesOrigen.vue?vue&type=style&index=0&id=62955a12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62955a12",
  null
  
)

export default component.exports